// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performance-tab {
  width: 100%;
  height: 100%;
  background: transparent;
}

.performance-tab > .performance-stats {
  display: flex;
  flex-direction: row;
  margin-top: 2em; /* ugly */
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/performance-tab/PerformanceTab.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,SAAS;AAC5B","sourcesContent":[".performance-tab {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n\n.performance-tab > .performance-stats {\n  display: flex;\n  flex-direction: row;\n  margin-top: 2em; /* ugly */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
